var runtime = require("../../../../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"icon":"WKZnt"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .WKZnt{height:6px!important;line-height:0!important}@media (max-width:599px){"+wrap+" .WKZnt{height:5px!important}}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

